import { http } from "./http";

export interface ResultBean {
  result: string;
}

export const zeroPad = (num: number, places: number) =>
  String(num).padStart(places, "0");

export const formatTimeSpan = (
  timeSpan: number,
  withHours: boolean = false
): string => {
  const hours = Math.floor(timeSpan / 3600);
  const minues = Math.floor((timeSpan % 3600) / 60);
  const seconds = (timeSpan % 3600) % 60;
  if (withHours) {
    return `${zeroPad(hours, 2)}:${zeroPad(minues, 2)}:${zeroPad(seconds, 2)}`;
  } else {
    return `${zeroPad(minues, 2)}:${zeroPad(seconds, 2)}`;
  }
};

export interface SelectOptionData {
  id: string;
  name: string;
}

export const getTeacherOptions = async (
  accessToken: string
): Promise<SelectOptionData[]> => {
  const path = `/Master/teachers`;
  const result = await http<SelectOptionData[]>({
    path: path,
    accessToken: accessToken,
  });
  if (result.ok && result.body) {
    return result.body;
  } else {
    return [];
  }
};

export const getSubjectOptions = async (
  accessToken: string,
  jid: string,
  fornotscoring?: string,
  forallocation?: string,
  forgroup?: string
): Promise<SelectOptionData[]> => {
  let path = `/Master/subjects`;
  path = path + `?jid=${jid}`;
  if (fornotscoring && fornotscoring != null && fornotscoring.length > 0) {
    path = path + "&fornotscoring=1";
  }
  if (forallocation && forallocation != null && forallocation.length > 0) {
    path = path + "&forallocation=1";
  }
  if (forgroup && forgroup != null && forgroup.length > 0) {
    path = path + "&forgroup=1";
  }
  const result = await http<SelectOptionData[]>({
    path: path,
    accessToken: accessToken,
  });
  if (result.ok && result.body) {
    return result.body;
  } else {
    return [];
  }
};

export const localeCompare = (a: any, b: any): number => {
  if (a && b) return a.localeCompare(b);
  else if (a && !b) return 1;
  else if (!a && b) return -1;
  else return 0;
};

export const makeid = (length: number): string => {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const isEmptyString = (str: string | undefined): boolean => {
  if (str && str !== null && str.length > 0) {
    return true;
  }
  return false;
};

export const isNullOrSpace = (str: string | undefined): boolean => {
  if (str === undefined || str == null || str.length === 0) {
    return true;
  }
  return false;
};

// 日付をYYYY-MM-DDの書式で返すメソッド
export const formatDate = (dt: any): string => {
  var y = dt.getFullYear();
  var m = ("00" + (dt.getMonth() + 1)).slice(-2);
  var d = ("00" + dt.getDate()).slice(-2);
  return y + "-" + m + "-" + d;
};
